import { render, staticRenderFns } from "./TransactionsLayout.vue?vue&type=template&id=30c18bb5&scoped=true&"
import script from "./TransactionsLayout.vue?vue&type=script&lang=js&"
export * from "./TransactionsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c18bb5",
  null
  
)

export default component.exports